"use client";

import { Link } from "@/i18n/routing";
import { useSetAtom } from "jotai";
import { mobileOpen } from "./MobileMenu";

export interface MobileMenuContentLinkProps {
	text: string;
	href: string;
	centraCategory?: string;
	className?: string;
}

export const MobileMenuContentLink = ({
	text,
	href,
	centraCategory,
	className,
}: MobileMenuContentLinkProps) => {
	const setOpen = useSetAtom(mobileOpen);
	return (
		<li onClick={() => setOpen(false)}>
			<Link
				href={centraCategory ? `${href}?categories=${centraCategory}` : href}
				className={className}
			>
				{text}
			</Link>
		</li>
	);
};
